/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum PaymentTypeFilterValuesEnum {
  PAYMENT_TYPE_UNSPECIFIED = 'PAYMENT_TYPE_UNSPECIFIED',
  PAYMENT_TYPE_PREPAID = 'PAYMENT_TYPE_PREPAID',
  PAYMENT_TYPE_PAY_ON_ARRIVAL = 'PAYMENT_TYPE_PAY_ON_ARRIVAL',
}

export enum CancellationTypeFilterValuesEnum {
  CANCELLATION_POLICY_TYPE_UNSPECIFIED = 'CANCELLATION_POLICY_TYPE_UNSPECIFIED',
  CANCELLATION_POLICY_TYPE_NON_REFUNDABLE = 'CANCELLATION_POLICY_TYPE_NON_REFUNDABLE',
  CANCELLATION_POLICY_TYPE_FREE_CANCELLATION = 'CANCELLATION_POLICY_TYPE_FREE_CANCELLATION',
  CANCELLATION_POLICY_TYPE_REFUNDABLE = 'CANCELLATION_POLICY_TYPE_REFUNDABLE',
}

export enum MealPlanFilterValuesEnum {
  MEAL_PLAN_TYPE_UNSPECIFIED = 'MEAL_PLAN_TYPE_UNSPECIFIED',
  MEAL_PLAN_TYPE_ALL_INCLUSIVE = 'MEAL_PLAN_TYPE_ALL_INCLUSIVE',
  MEAL_PLAN_TYPE_BREAKFAST_INCLUDED = 'MEAL_PLAN_TYPE_BREAKFAST_INCLUDED',
  MEAL_PLAN_TYPE_FULL_BOARD = 'MEAL_PLAN_TYPE_FULL_BOARD',
  MEAL_PLAN_TYPE_HALF_BOARD = 'MEAL_PLAN_TYPE_HALF_BOARD',
  MEAL_PLAN_TYPE_ROOM_ONLY = 'MEAL_PLAN_TYPE_ROOM_ONLY',
}

export enum StarsFilterValuesEnum {
  STARS_UNSPECIFIED = 'STARS_UNSPECIFIED',
  STARS_NO_STAR = 'STARS_NO_STAR',
  STARS_ONE_STAR = 'STARS_ONE_STAR',
  STARS_TWO_STAR = 'STARS_TWO_STAR',
  STARS_THREE_STAR = 'STARS_THREE_STAR',
  STARS_FOUR_STAR = 'STARS_FOUR_STAR',
  STARS_FIVE_STAR = 'STARS_FIVE_STAR',
}

/**
 * Sort direction
 * @example "SORT_ORDER_DIRECTION_ASCENDING"
 */
export enum SortOrder {
  SORT_ORDER_DIRECTION_UNSPECIFIED = 'SORT_ORDER_DIRECTION_UNSPECIFIED',
  SORT_ORDER_DIRECTION_ASCENDING = 'SORT_ORDER_DIRECTION_ASCENDING',
  SORT_ORDER_DIRECTION_DESCENDING = 'SORT_ORDER_DIRECTION_DESCENDING',
}

/**
 * Field to sort by
 * @example "SORT_ORDER_TYPE_PRICE"
 */
export enum SortType {
  SORT_ORDER_TYPE_UNSPECIFIED = 'SORT_ORDER_TYPE_UNSPECIFIED',
  SORT_ORDER_TYPE_PRICE = 'SORT_ORDER_TYPE_PRICE',
  SORT_ORDER_TYPE_HOTEL_GUEST_RATING = 'SORT_ORDER_TYPE_HOTEL_GUEST_RATING',
  SORT_ORDER_TYPE_HOTEL_PROXIMITY = 'SORT_ORDER_TYPE_HOTEL_PROXIMITY',
  SORT_ORDER_TYPE_HOTEL_STAR_RATING = 'SORT_ORDER_TYPE_HOTEL_STAR_RATING',
  SORT_ORDER_TYPE_HOTEL_DISCOUNT = 'SORT_ORDER_TYPE_HOTEL_DISCOUNT',
  SORT_ORDER_TYPE_BEST = 'SORT_ORDER_TYPE_BEST',
}

export interface Distance {
  /** @example 15.5 */
  value?: number
  /** @example "DISTANCE_UNIT_KILOMETER" */
  unitCode?: DistanceUnitCodeEnum
}

export interface HotelsAutosuggestRequest {
  query: HotelsQuery
  /**
   * Maximum number of results
   * @min 1
   * @max 50
   * @default 10
   * @example 20
   */
  limit?: number
}

export interface HotelsQuery {
  /**
   * @pattern ^[A-Z]{2}$
   * @example "UK"
   */
  market: string
  /**
   * @pattern ^[a-z]{2}-[A-Z]{2}$
   * @example "en-GB"
   */
  locale: string
  /**
   * Search term. Empty string returns popular hotels.
   * @maxLength 100
   * @example "paris"
   */
  searchTerm: string
  /** Filter by entity types */
  includedEntityTypes?: HotelsQueryIncludedEntityTypesEnum[]
}

export interface HotelsAutosuggestResponse {
  places?: HotelsPlace[]
}

export interface HotelsPlace {
  /** @example "Paris|Île-de-France|France" */
  hierarchy?: string
  /** @example "48.8566, 2.3522" */
  location?: string
  /**
   * Relevance score
   * @example 0.95
   */
  score?: number
  /** @example "Paris" */
  name?: string
  highlight?: HotelsHighlight
  /** @example "27539733" */
  entityId?: string
  /** @example "PLACE_TYPE_CITY" */
  type?: HotelsPlaceTypeEnum
  /** Points of interest near this location */
  pois?: PointOfInterest[]
}

export interface HotelsHighlight {
  /** @example "<em>Paris</em>|Île-de-France|France" */
  hierarchy?: string
  /** @example "<em>Paris</em>" */
  name?: string
}

export interface PointOfInterest {
  /** @example "Eiffel Tower" */
  name?: string
  /** @example "27539734" */
  entityId?: string
  type?: string
}

export interface HotelSearchCreateRequest {
  query: HotelSearchQuery
  /**
   * Number of hotels in initial response
   * @min 1
   * @max 50
   * @example 20
   */
  initialPageSize: number
}

export interface HotelSearchQuery {
  /**
   * @pattern ^[A-Z]{2}$
   * @example "UK"
   */
  market: string
  /**
   * @pattern ^[a-z]{2}-[A-Z]{2}$
   * @example "en-GB"
   */
  locale: string
  /**
   * Currency code (ISO 4217)
   * @pattern ^[A-Z]{3}$
   * @example "GBP"
   */
  currency: string
  /**
   * Place ID from autosuggest
   * @example "27544008"
   */
  entityId: string
  checkinDate: DateObject
  checkoutDate: DateObject
  /**
   * Number of adult travelers
   * @min 1
   * @example 2
   */
  adults: number
  /**
   * Ages of child travelers
   * @example [5,8]
   */
  childrenAges?: number[]
  /**
   * Number of rooms to book
   * @min 1
   * @example 1
   */
  rooms: number
  /** Only include these booking agents */
  includedAgentsIds?: string[]
  /** Exclude these booking agents */
  excludedAgentsIds?: string[]
}

export interface DateObject {
  /**
   * @min 2024
   * @max 2030
   * @example 2024
   */
  year: number
  /**
   * @min 1
   * @max 12
   * @example 12
   */
  month: number
  /**
   * @min 1
   * @max 31
   * @example 25
   */
  day: number
}

export interface HotelSearchPollRequest {
  pagination: Pagination
  sort?: Sort
  filters?: Filter[]
}

export interface Pagination {
  /**
   * Number of results to skip
   * @min 0
   * @example 0
   */
  offset: number
  /**
   * Number of results to return
   * @min 1
   * @max 100
   * @example 20
   */
  limit: number
}

export interface Sort {
  /**
   * Field to sort by
   * @example "SORT_ORDER_TYPE_PRICE"
   */
  type: SortType
  /**
   * Sort direction
   * @example "SORT_ORDER_DIRECTION_ASCENDING"
   */
  order: SortOrder
}

/** At least one filter type must be specified */
export interface Filter {
  starsFilter?: StarsFilter
  chainIdFilter?: StringListFilter
  hotelGroupFilter?: StringListFilter
  priceRangeFilter?: PriceRangeFilter
  hotelAmenitiesFilter?: HotelAmenitiesFilter
  hotelGuestTypeFilter?: HotelGuestTypeFilter
  accommodationTypeFilter?: StringListFilter
  mealPlanFilter?: MealPlanFilter
  cancellationTypeFilter?: CancellationTypeFilter
  paymentTypeFilter?: PaymentTypeFilter
  geoAreaFilter?: GeoAreaFilter
  agentFilter?: StringListFilter
}

export interface StarsFilter {
  /** @example ["STARS_FOUR_STAR","STARS_FIVE_STAR"] */
  values: StarsFilterValuesEnum[]
}

export interface HotelGuestTypeFilter {
  /** @example ["GUEST_TYPE_FAMILY","GUEST_TYPE_COUPLE"] */
  values: HotelGuestTypeFilterValuesEnum[]
}

export interface MealPlanFilter {
  /** @example ["MEAL_PLAN_TYPE_ALL_INCLUSIVE","MEAL_PLAN_TYPE_BREAKFAST_INCLUDED"] */
  values: MealPlanFilterValuesEnum[]
}

export interface CancellationTypeFilter {
  /** @example ["CANCELLATION_POLICY_TYPE_NON_REFUNDABLE","CANCELLATION_POLICY_TYPE_FREE_CANCELLATION"] */
  values: CancellationTypeFilterValuesEnum[]
}

export interface PaymentTypeFilter {
  /** @example ["PAYMENT_TYPE_PREPAID"] */
  values: PaymentTypeFilterValuesEnum[]
}

export interface HotelAmenitiesFilter {
  /** @example ["HOTEL_AMENITY_WIFI_SERVICE","HOTEL_AMENITY_POOL","HOTEL_AMENITY_PARKING"] */
  values: HotelAmenitiesFilterValuesEnum[]
}

export enum HotelAmenitiesFilterValuesEnum {
  HOTEL_AMENITY_UNSPECIFIED = 'HOTEL_AMENITY_UNSPECIFIED',
  HOTEL_AMENITY_FRONT_DESK_24H_SERVICE = 'HOTEL_AMENITY_FRONT_DESK_24H_SERVICE',
  HOTEL_AMENITY_AIR_CONDITIONING = 'HOTEL_AMENITY_AIR_CONDITIONING',
  HOTEL_AMENITY_AIRPORT_SHUTTLE_SERVICE = 'HOTEL_AMENITY_AIRPORT_SHUTTLE_SERVICE',
  HOTEL_AMENITY_BABY_SITTING_SERVICE = 'HOTEL_AMENITY_BABY_SITTING_SERVICE',
  HOTEL_AMENITY_BAR = 'HOTEL_AMENITY_BAR',
  HOTEL_AMENITY_BEAUTY_SALON = 'HOTEL_AMENITY_BEAUTY_SALON',
  HOTEL_AMENITY_BROADBAND_SERVICE = 'HOTEL_AMENITY_BROADBAND_SERVICE',
  HOTEL_AMENITY_BUSINESS_CENTER = 'HOTEL_AMENITY_BUSINESS_CENTER',
  HOTEL_AMENITY_CD_PLAYER = 'HOTEL_AMENITY_CD_PLAYER',
  HOTEL_AMENITY_CHILDREN_FACILITY = 'HOTEL_AMENITY_CHILDREN_FACILITY',
  HOTEL_AMENITY_COFFEE_MAKER = 'HOTEL_AMENITY_COFFEE_MAKER',
  HOTEL_AMENITY_CONCIERGE_SERVICE = 'HOTEL_AMENITY_CONCIERGE_SERVICE',
  HOTEL_AMENITY_CONNECTING_ROOMS_SERVICE = 'HOTEL_AMENITY_CONNECTING_ROOMS_SERVICE',
  HOTEL_AMENITY_COT = 'HOTEL_AMENITY_COT',
  HOTEL_AMENITY_CURRENCY_EXCHANGE_SERVICE = 'HOTEL_AMENITY_CURRENCY_EXCHANGE_SERVICE',
  HOTEL_AMENITY_DVD_VIDEO_PLAYER = 'HOTEL_AMENITY_DVD_VIDEO_PLAYER',
  HOTEL_AMENITY_DISABLED_FACILITY = 'HOTEL_AMENITY_DISABLED_FACILITY',
  HOTEL_AMENITY_DOCTOR_ON_CALL_SERVICE = 'HOTEL_AMENITY_DOCTOR_ON_CALL_SERVICE',
  HOTEL_AMENITY_FITNESS_CENTER = 'HOTEL_AMENITY_FITNESS_CENTER',
  HOTEL_AMENITY_GYMNASIUM = 'HOTEL_AMENITY_GYMNASIUM',
  HOTEL_AMENITY_HAIR_DRYER = 'HOTEL_AMENITY_HAIR_DRYER',
  HOTEL_AMENITY_INDOOR_SWIMMING_POOL = 'HOTEL_AMENITY_INDOOR_SWIMMING_POOL',
  HOTEL_AMENITY_IRONING_SERVICE = 'HOTEL_AMENITY_IRONING_SERVICE',
  HOTEL_AMENITY_JACUZZI = 'HOTEL_AMENITY_JACUZZI',
  HOTEL_AMENITY_LAUNDRY = 'HOTEL_AMENITY_LAUNDRY',
  HOTEL_AMENITY_LIFT = 'HOTEL_AMENITY_LIFT',
  HOTEL_AMENITY_MASSAGE_SERVICE = 'HOTEL_AMENITY_MASSAGE_SERVICE',
  HOTEL_AMENITY_MEETING_ROOM = 'HOTEL_AMENITY_MEETING_ROOM',
  HOTEL_AMENITY_MINI_BAR = 'HOTEL_AMENITY_MINI_BAR',
  HOTEL_AMENITY_MODEM = 'HOTEL_AMENITY_MODEM',
  HOTEL_AMENITY_NON_SMOKING_SERVICE = 'HOTEL_AMENITY_NON_SMOKING_SERVICE',
  HOTEL_AMENITY_OUTDOOR_SWIMMING_POOL = 'HOTEL_AMENITY_OUTDOOR_SWIMMING_POOL',
  HOTEL_AMENITY_PARKING = 'HOTEL_AMENITY_PARKING',
  HOTEL_AMENITY_PETS_ALLOWED_SERVICE = 'HOTEL_AMENITY_PETS_ALLOWED_SERVICE',
  HOTEL_AMENITY_RESTAURANT = 'HOTEL_AMENITY_RESTAURANT',
  HOTEL_AMENITY_ROOM_SERVICE = 'HOTEL_AMENITY_ROOM_SERVICE',
  HOTEL_AMENITY_SAFE_DEPOSIT_BOX = 'HOTEL_AMENITY_SAFE_DEPOSIT_BOX',
  HOTEL_AMENITY_SATELLITE_TV = 'HOTEL_AMENITY_SATELLITE_TV',
  HOTEL_AMENITY_SAUNA = 'HOTEL_AMENITY_SAUNA',
  HOTEL_AMENITY_SMOKING_SERVICE = 'HOTEL_AMENITY_SMOKING_SERVICE',
  HOTEL_AMENITY_SOLARIUM = 'HOTEL_AMENITY_SOLARIUM',
  HOTEL_AMENITY_TELEVISION = 'HOTEL_AMENITY_TELEVISION',
  HOTEL_AMENITY_TELEPHONE = 'HOTEL_AMENITY_TELEPHONE',
  HOTEL_AMENITY_TENNIS_COURT = 'HOTEL_AMENITY_TENNIS_COURT',
  HOTEL_AMENITY_WAKE_UP_CALL_SERVICE = 'HOTEL_AMENITY_WAKE_UP_CALL_SERVICE',
  HOTEL_AMENITY_WHEEL_CHAIR_ACCESS = 'HOTEL_AMENITY_WHEEL_CHAIR_ACCESS',
  HOTEL_AMENITY_WIFI_SERVICE = 'HOTEL_AMENITY_WIFI_SERVICE',
  HOTEL_AMENITY_BALCONY = 'HOTEL_AMENITY_BALCONY',
  HOTEL_AMENITY_BATHROBE_SERVICE = 'HOTEL_AMENITY_BATHROBE_SERVICE',
  HOTEL_AMENITY_BATHTUB = 'HOTEL_AMENITY_BATHTUB',
  HOTEL_AMENITY_CAFE = 'HOTEL_AMENITY_CAFE',
  HOTEL_AMENITY_CASINO = 'HOTEL_AMENITY_CASINO',
  HOTEL_AMENITY_BOTTLED_WATER_SERVICE = 'HOTEL_AMENITY_BOTTLED_WATER_SERVICE',
  HOTEL_AMENITY_DAILY_NEWSPAPER_SERVICE = 'HOTEL_AMENITY_DAILY_NEWSPAPER_SERVICE',
  HOTEL_AMENITY_DESK = 'HOTEL_AMENITY_DESK',
  HOTEL_AMENITY_EXECUTIVE_FLOOR = 'HOTEL_AMENITY_EXECUTIVE_FLOOR',
  HOTEL_AMENITY_INTERNET_ACCESS_SERVICE = 'HOTEL_AMENITY_INTERNET_ACCESS_SERVICE',
  HOTEL_AMENITY_KITCHENETTE = 'HOTEL_AMENITY_KITCHENETTE',
  HOTEL_AMENITY_MICROWAVE = 'HOTEL_AMENITY_MICROWAVE',
  HOTEL_AMENITY_NIGHTCLUB = 'HOTEL_AMENITY_NIGHTCLUB',
  HOTEL_AMENITY_RADIO_SERVICE = 'HOTEL_AMENITY_RADIO_SERVICE',
  HOTEL_AMENITY_SECRETARY_SERVICE = 'HOTEL_AMENITY_SECRETARY_SERVICE',
  HOTEL_AMENITY_SHOP = 'HOTEL_AMENITY_SHOP',
  HOTEL_AMENITY_SHOWER = 'HOTEL_AMENITY_SHOWER',
  HOTEL_AMENITY_STEAM_ROOM = 'HOTEL_AMENITY_STEAM_ROOM',
  HOTEL_AMENITY_THEMATIC_TV_SERVICE = 'HOTEL_AMENITY_THEMATIC_TV_SERVICE',
  HOTEL_AMENITY_TOUR_SERVICE = 'HOTEL_AMENITY_TOUR_SERVICE',
  HOTEL_AMENITY_TRANSLATION_SERVICE = 'HOTEL_AMENITY_TRANSLATION_SERVICE',
  HOTEL_AMENITY_TROUSER_PRESS = 'HOTEL_AMENITY_TROUSER_PRESS',
  HOTEL_AMENITY_VIDEOGAME_SERVICE = 'HOTEL_AMENITY_VIDEOGAME_SERVICE',
  HOTEL_AMENITY_SPA = 'HOTEL_AMENITY_SPA',
  HOTEL_AMENITY_SQUASH_COURT = 'HOTEL_AMENITY_SQUASH_COURT',
  HOTEL_AMENITY_BICYCLE_RENTAL_SERVICE = 'HOTEL_AMENITY_BICYCLE_RENTAL_SERVICE',
  HOTEL_AMENITY_VALET_PARKING_SERVICE = 'HOTEL_AMENITY_VALET_PARKING_SERVICE',
  HOTEL_AMENITY_ALARM_CLOCK = 'HOTEL_AMENITY_ALARM_CLOCK',
  HOTEL_AMENITY_ANIMATION_SERVICE = 'HOTEL_AMENITY_ANIMATION_SERVICE',
  HOTEL_AMENITY_BANQUETING_SERVICE = 'HOTEL_AMENITY_BANQUETING_SERVICE',
  HOTEL_AMENITY_BARBEQUE = 'HOTEL_AMENITY_BARBEQUE',
  HOTEL_AMENITY_BASKETBALL_COURT = 'HOTEL_AMENITY_BASKETBALL_COURT',
  HOTEL_AMENITY_SUN_UMBRELLA = 'HOTEL_AMENITY_SUN_UMBRELLA',
  HOTEL_AMENITY_BELL_STAFF_SERVICE = 'HOTEL_AMENITY_BELL_STAFF_SERVICE',
  HOTEL_AMENITY_BICYCLE_STORAGE = 'HOTEL_AMENITY_BICYCLE_STORAGE',
  HOTEL_AMENITY_BILLIARDS = 'HOTEL_AMENITY_BILLIARDS',
  HOTEL_AMENITY_BINGO = 'HOTEL_AMENITY_BINGO',
  HOTEL_AMENITY_BOWLING_ALLEY = 'HOTEL_AMENITY_BOWLING_ALLEY',
  HOTEL_AMENITY_BREAKFAST_ROOM = 'HOTEL_AMENITY_BREAKFAST_ROOM',
  HOTEL_AMENITY_BREAKFAST_TO_GO = 'HOTEL_AMENITY_BREAKFAST_TO_GO',
  HOTEL_AMENITY_BUTLER_SERVICE = 'HOTEL_AMENITY_BUTLER_SERVICE',
  HOTEL_AMENITY_CAR_RENTAL = 'HOTEL_AMENITY_CAR_RENTAL',
  HOTEL_AMENITY_CASH_MACHINE = 'HOTEL_AMENITY_CASH_MACHINE',
  HOTEL_AMENITY_CHAPEL = 'HOTEL_AMENITY_CHAPEL',
  HOTEL_AMENITY_CONFERENCE_FACILITY = 'HOTEL_AMENITY_CONFERENCE_FACILITY',
  HOTEL_AMENITY_CONGRESS_FACILITY = 'HOTEL_AMENITY_CONGRESS_FACILITY',
  HOTEL_AMENITY_DINING_ROOM = 'HOTEL_AMENITY_DINING_ROOM',
  HOTEL_AMENITY_DIVING_SERVICE = 'HOTEL_AMENITY_DIVING_SERVICE',
  HOTEL_AMENITY_DOORMAN_SERVICE = 'HOTEL_AMENITY_DOORMAN_SERVICE',
  HOTEL_AMENITY_DVD_VIDEO_LIBRARY_SERVICE = 'HOTEL_AMENITY_DVD_VIDEO_LIBRARY_SERVICE',
  HOTEL_AMENITY_EARLY_CHECKIN_SERVICE = 'HOTEL_AMENITY_EARLY_CHECKIN_SERVICE',
  HOTEL_AMENITY_ENTERTAINMENT_ROOMS = 'HOTEL_AMENITY_ENTERTAINMENT_ROOMS',
  HOTEL_AMENITY_EXPRESS_CHECKIN_SERVICE = 'HOTEL_AMENITY_EXPRESS_CHECKIN_SERVICE',
  HOTEL_AMENITY_EXPRESS_CHECKOUT_SERVICE = 'HOTEL_AMENITY_EXPRESS_CHECKOUT_SERVICE',
  HOTEL_AMENITY_EXTRA_BED = 'HOTEL_AMENITY_EXTRA_BED',
  HOTEL_AMENITY_FAX = 'HOTEL_AMENITY_FAX',
  HOTEL_AMENITY_FIREPLACE = 'HOTEL_AMENITY_FIREPLACE',
  HOTEL_AMENITY_GAME_ROOM = 'HOTEL_AMENITY_GAME_ROOM',
  HOTEL_AMENITY_GARDEN = 'HOTEL_AMENITY_GARDEN',
  HOTEL_AMENITY_HAIRDRESSERS = 'HOTEL_AMENITY_HAIRDRESSERS',
  HOTEL_AMENITY_HEATING = 'HOTEL_AMENITY_HEATING',
  HOTEL_AMENITY_HORSE_RIDING_SERVICE = 'HOTEL_AMENITY_HORSE_RIDING_SERVICE',
  HOTEL_AMENITY_JACUZZI_BATHTUB = 'HOTEL_AMENITY_JACUZZI_BATHTUB',
  HOTEL_AMENITY_KITCHEN = 'HOTEL_AMENITY_KITCHEN',
  HOTEL_AMENITY_LATE_CHECKOUT_SERVICE = 'HOTEL_AMENITY_LATE_CHECKOUT_SERVICE',
  HOTEL_AMENITY_LIBRARY = 'HOTEL_AMENITY_LIBRARY',
  HOTEL_AMENITY_LIMOUSINE_SERVICE = 'HOTEL_AMENITY_LIMOUSINE_SERVICE',
  HOTEL_AMENITY_LOUNGE = 'HOTEL_AMENITY_LOUNGE',
  HOTEL_AMENITY_LUGGAGE_STORAGE = 'HOTEL_AMENITY_LUGGAGE_STORAGE',
  HOTEL_AMENITY_MARINA = 'HOTEL_AMENITY_MARINA',
  HOTEL_AMENITY_MEDICAL_SERVICE = 'HOTEL_AMENITY_MEDICAL_SERVICE',
  HOTEL_AMENITY_MINIGOLF = 'HOTEL_AMENITY_MINIGOLF',
  HOTEL_AMENITY_MULTILINGUAL_STAFF_SERVICE = 'HOTEL_AMENITY_MULTILINGUAL_STAFF_SERVICE',
  HOTEL_AMENITY_NURSERY = 'HOTEL_AMENITY_NURSERY',
  HOTEL_AMENITY_PADEL_TENNIS = 'HOTEL_AMENITY_PADEL_TENNIS',
  HOTEL_AMENITY_PHARMACY = 'HOTEL_AMENITY_PHARMACY',
  HOTEL_AMENITY_PHOTOCOPIER = 'HOTEL_AMENITY_PHOTOCOPIER',
  HOTEL_AMENITY_PLAYGROUND = 'HOTEL_AMENITY_PLAYGROUND',
  HOTEL_AMENITY_POOL_BAR = 'HOTEL_AMENITY_POOL_BAR',
  HOTEL_AMENITY_PRIVATE_BEACH = 'HOTEL_AMENITY_PRIVATE_BEACH',
  HOTEL_AMENITY_READING_AREA = 'HOTEL_AMENITY_READING_AREA',
  HOTEL_AMENITY_RECEPTION_AREA = 'HOTEL_AMENITY_RECEPTION_AREA',
  HOTEL_AMENITY_SAILING_SERVICE = 'HOTEL_AMENITY_SAILING_SERVICE',
  HOTEL_AMENITY_SECURITY_SERVICE = 'HOTEL_AMENITY_SECURITY_SERVICE',
  HOTEL_AMENITY_SHOE_POLISHING_SERVICE = 'HOTEL_AMENITY_SHOE_POLISHING_SERVICE',
  HOTEL_AMENITY_SHUTTLE_SERVICE = 'HOTEL_AMENITY_SHUTTLE_SERVICE',
  HOTEL_AMENITY_SKI_SHUTTLE_SERVICE = 'HOTEL_AMENITY_SKI_SHUTTLE_SERVICE',
  HOTEL_AMENITY_SKI_STORAGE = 'HOTEL_AMENITY_SKI_STORAGE',
  HOTEL_AMENITY_SMOKING_AREA = 'HOTEL_AMENITY_SMOKING_AREA',
  HOTEL_AMENITY_STATION_SHUTTLE_SERVICE = 'HOTEL_AMENITY_STATION_SHUTTLE_SERVICE',
  HOTEL_AMENITY_SUPERMARKET = 'HOTEL_AMENITY_SUPERMARKET',
  HOTEL_AMENITY_TABLE_TENNIS = 'HOTEL_AMENITY_TABLE_TENNIS',
  HOTEL_AMENITY_TICKET_OFFICE = 'HOTEL_AMENITY_TICKET_OFFICE',
  HOTEL_AMENITY_TOURIST_INFORMATION_OFFICE = 'HOTEL_AMENITY_TOURIST_INFORMATION_OFFICE',
  HOTEL_AMENITY_TURKISH_BATH = 'HOTEL_AMENITY_TURKISH_BATH',
  HOTEL_AMENITY_UV_SUNBEDS = 'HOTEL_AMENITY_UV_SUNBEDS',
  HOTEL_AMENITY_VOICE_MAIL_SERVICE = 'HOTEL_AMENITY_VOICE_MAIL_SERVICE',
  HOTEL_AMENITY_WATER_SPORTS_SERVICE = 'HOTEL_AMENITY_WATER_SPORTS_SERVICE',
  HOTEL_AMENITY_WEDDING_FACILITY = 'HOTEL_AMENITY_WEDDING_FACILITY',
  HOTEL_AMENITY_ROOM_WITH_A_VIEW = 'HOTEL_AMENITY_ROOM_WITH_A_VIEW',
  HOTEL_AMENITY_ROOM_WITH_A_SEA_VIEW = 'HOTEL_AMENITY_ROOM_WITH_A_SEA_VIEW',
  HOTEL_AMENITY_ROOM_WITH_A_LAKE_VIEW = 'HOTEL_AMENITY_ROOM_WITH_A_LAKE_VIEW',
  HOTEL_AMENITY_ROOM_WITH_A_MOUNTAIN_VIEW = 'HOTEL_AMENITY_ROOM_WITH_A_MOUNTAIN_VIEW',
  HOTEL_AMENITY_DECK_LOUNGER = 'HOTEL_AMENITY_DECK_LOUNGER',
  HOTEL_AMENITY_INDOOR_PARKING = 'HOTEL_AMENITY_INDOOR_PARKING',
  HOTEL_AMENITY_OUTDOOR_PARKING = 'HOTEL_AMENITY_OUTDOOR_PARKING',
  HOTEL_AMENITY_CHILDREN_POOL = 'HOTEL_AMENITY_CHILDREN_POOL',
  HOTEL_AMENITY_POOL = 'HOTEL_AMENITY_POOL',
  HOTEL_AMENITY_ROOM_JACUZZI = 'HOTEL_AMENITY_ROOM_JACUZZI',
  HOTEL_AMENITY_ROOM_POOL = 'HOTEL_AMENITY_ROOM_POOL',
  HOTEL_AMENITY_GOLF_AMENITY = 'HOTEL_AMENITY_GOLF_AMENITY',
  HOTEL_AMENITY_HOT_SPRING = 'HOTEL_AMENITY_HOT_SPRING',
  HOTEL_AMENITY_PRIVATE_HOT_SPRING_BATH = 'HOTEL_AMENITY_PRIVATE_HOT_SPRING_BATH',
  HOTEL_AMENITY_OUTDOOR_HOT_SPRING_BATH = 'HOTEL_AMENITY_OUTDOOR_HOT_SPRING_BATH',
  HOTEL_AMENITY_RUNNING_NATURAL_HOT_SPRING_BATH = 'HOTEL_AMENITY_RUNNING_NATURAL_HOT_SPRING_BATH',
  HOTEL_AMENITY_NONSMOKING_FLOOR = 'HOTEL_AMENITY_NONSMOKING_FLOOR',
  HOTEL_AMENITY_NO_ELEVATOR = 'HOTEL_AMENITY_NO_ELEVATOR',
  HOTEL_AMENITY_WIFI_IN_DESIGNATED_AREAS = 'HOTEL_AMENITY_WIFI_IN_DESIGNATED_AREAS',
  HOTEL_AMENITY_FREE_WIFI_IN_DESIGNATED_AREAS = 'HOTEL_AMENITY_FREE_WIFI_IN_DESIGNATED_AREAS',
  HOTEL_AMENITY_LOBBY_BAR = 'HOTEL_AMENITY_LOBBY_BAR',
  HOTEL_AMENITY_FIRST_AID_ROOM = 'HOTEL_AMENITY_FIRST_AID_ROOM',
  HOTEL_AMENITY_ATM = 'HOTEL_AMENITY_ATM',
  HOTEL_AMENITY_CHINESE_RESTAURANT = 'HOTEL_AMENITY_CHINESE_RESTAURANT',
  HOTEL_AMENITY_TEAHOUSE = 'HOTEL_AMENITY_TEAHOUSE',
  HOTEL_AMENITY_WESTERN_RESTAURANT = 'HOTEL_AMENITY_WESTERN_RESTAURANT',
  HOTEL_AMENITY_EXECUTIVE_LOUNGE = 'HOTEL_AMENITY_EXECUTIVE_LOUNGE',
  HOTEL_AMENITY_KARAOKE = 'HOTEL_AMENITY_KARAOKE',
  HOTEL_AMENITY_CHESS_ROOM = 'HOTEL_AMENITY_CHESS_ROOM',
  HOTEL_AMENITY_SUNBATHING_AREA = 'HOTEL_AMENITY_SUNBATHING_AREA',
  HOTEL_AMENITY_SNORKELING = 'HOTEL_AMENITY_SNORKELING',
  HOTEL_AMENITY_TOILET_WITH_ARM_SUPPORT = 'HOTEL_AMENITY_TOILET_WITH_ARM_SUPPORT',
  HOTEL_AMENITY_SHOWER_SEAT = 'HOTEL_AMENITY_SHOWER_SEAT',
  HOTEL_AMENITY_LOW_SINK = 'HOTEL_AMENITY_LOW_SINK',
  HOTEL_AMENITY_BATH_WITH_ARM_SUPPORT = 'HOTEL_AMENITY_BATH_WITH_ARM_SUPPORT',
  HOTEL_AMENITY_BATHROOM_EMERGENCY_CALL_BUTTON = 'HOTEL_AMENITY_BATHROOM_EMERGENCY_CALL_BUTTON',
  HOTEL_AMENITY_ELECTRIC_VEHICLE_CHARGING_STATION = 'HOTEL_AMENITY_ELECTRIC_VEHICLE_CHARGING_STATION',
  HOTEL_AMENITY_ACCESSIBLE_PARKING = 'HOTEL_AMENITY_ACCESSIBLE_PARKING',
  HOTEL_AMENITY_ACCESSIBLE_ROOMS_AVAILABLE = 'HOTEL_AMENITY_ACCESSIBLE_ROOMS_AVAILABLE',
  HOTEL_AMENITY_ASSISTIVE_LISTENING_DEVICES_AVAILABLE = 'HOTEL_AMENITY_ASSISTIVE_LISTENING_DEVICES_AVAILABLE',
  HOTEL_AMENITY_AUDITORY_GUIDANCE = 'HOTEL_AMENITY_AUDITORY_GUIDANCE',
  HOTEL_AMENITY_BATHROOM_EMERGENCY_PULL_CORD = 'HOTEL_AMENITY_BATHROOM_EMERGENCY_PULL_CORD',
  HOTEL_AMENITY_BATH_SEAT = 'HOTEL_AMENITY_BATH_SEAT',
  HOTEL_AMENITY_BATH_WITH_GRAB_BAR = 'HOTEL_AMENITY_BATH_WITH_GRAB_BAR',
  HOTEL_AMENITY_BRAILLE_OR_TACTILE_SIGNAGE = 'HOTEL_AMENITY_BRAILLE_OR_TACTILE_SIGNAGE',
  HOTEL_AMENITY_HANDRAILS_IN_STAIRWAYS = 'HOTEL_AMENITY_HANDRAILS_IN_STAIRWAYS',
  HOTEL_AMENITY_LOWERED_BATHROOM_SINK = 'HOTEL_AMENITY_LOWERED_BATHROOM_SINK',
  HOTEL_AMENITY_PHONE_ACCESSIBILITY_AVAILABLE = 'HOTEL_AMENITY_PHONE_ACCESSIBILITY_AVAILABLE',
  HOTEL_AMENITY_RAISED_TOILET = 'HOTEL_AMENITY_RAISED_TOILET',
  HOTEL_AMENITY_ROLL_IN_SHOWER = 'HOTEL_AMENITY_ROLL_IN_SHOWER',
  HOTEL_AMENITY_SHOWER_WITH_GRAB_BAR = 'HOTEL_AMENITY_SHOWER_WITH_GRAB_BAR',
  HOTEL_AMENITY_SIGN_LANGUAGE_CAPABLE_STAFF = 'HOTEL_AMENITY_SIGN_LANGUAGE_CAPABLE_STAFF',
  HOTEL_AMENITY_TOILET_WITH_GRAB_BAR = 'HOTEL_AMENITY_TOILET_WITH_GRAB_BAR',
  HOTEL_AMENITY_TRANSFER_SHOWER = 'HOTEL_AMENITY_TRANSFER_SHOWER',
  HOTEL_AMENITY_VISUAL_ALARMS = 'HOTEL_AMENITY_VISUAL_ALARMS',
  HOTEL_AMENITY_WATER_SLIDE = 'HOTEL_AMENITY_WATER_SLIDE',
  HOTEL_AMENITY_FIRST_AID_KIT = 'HOTEL_AMENITY_FIRST_AID_KIT',
  HOTEL_AMENITY_FIRE_EXTINGUISHERS = 'HOTEL_AMENITY_FIRE_EXTINGUISHERS',
}

export interface StringListFilter {
  /** @example ["WIFI","POOL","PARKING"] */
  values: string[]
}

export interface PriceRangeFilter {
  /**
   * @min 0
   * @example 100
   */
  minValue?: number
  /**
   * @min 0
   * @example 300
   */
  maxValue?: number
}

export interface GeoAreaFilter {
  /**
   * Map points defining the area. A rectangular area with the first coordinate the south-east and the second the north-west of the rectangle.
   * @minItems 2
   * @maxItems 2
   */
  coordinates: Coordinates[]
}

export interface Coordinates {
  /**
   * @min -90
   * @max 90
   * @example 51.5074
   */
  latitude: number
  /**
   * @min -180
   * @max 180
   * @example -0.1278
   */
  longitude: number
}

export interface HotelSearchResponse {
  /**
   * Token for polling this search
   * @example "abc123def456"
   */
  sessionToken: string
  /**
   * Current search status
   * @example "RESULT_STATUS_INCOMPLETE"
   */
  status: HotelSearchResponseStatusEnum
  content?: HotelSearchContent
}

export interface HotelSearchContent {
  /**
   * Total number of hotels found
   * @example 150
   */
  totalHotelResultCount?: number
  results?: HotelResults
}

export interface HotelResults {
  /** Map of hotel IDs to pricing options */
  hotelsPricingOptions?: Record<string, PricingOption>
  agents?: Record<string, Agent>
  hotelInfo?: Record<string, HotelInfo>
  hotelContent?: Record<string, HotelContent>
  sortOptions?: SortOptions
}

export interface Agent {
  /** @example "booking_com" */
  id?: string
  /**
   * @format uri
   * @example "https://example.com/logos/booking.png"
   */
  logoUrl?: string
  /** @example "AGENT_TYPE_OTA" */
  agentType?: AgentAgentTypeEnum
  /** @example "Booking.com" */
  name?: string
}

export interface HotelInfo {
  /** @example "12345" */
  hotelId?: string
  distanceFromTarget?: Distance
  /**
   * Direct booking link
   * @format uri
   */
  deeplink?: string
}

export interface HotelContent {
  /** @example "12345" */
  hotelId?: string
  /** @example "Grand Hotel" */
  hotelName?: string
  /** @example "STARS_TWO_STAR" */
  stars?: StarsFilterValuesEnum
  /** @example "ACCOM_TYPE_HOTEL" */
  accommodationType?: HotelContentAccommodationTypeEnum
  chainGroup?: ChainGroup
  coordinates?: Coordinates
  hotelImages?: HotelImage[]
  guestRating?: GuestRating
}

export interface ChainGroup {
  /** @example 123 */
  chainId?: number
  /** @example "Marriott" */
  chainName?: string
  /** @example 456 */
  groupId?: number
  /** @example "Marriott International" */
  groupName?: string
}

export interface GuestRating {
  /**
   * @min 1
   * @max 5
   * @example 4.5
   */
  score: number
  /**
   * @example 1250
   */
  reviewCount: number
}

export interface HotelImage {
  /** @example "img_001" */
  id?: string
  /** @example "IMAGE_TYPE_INTERIOR" */
  type?: HotelImageTypeEnum
  /** @format uri */
  thumbnailUrl?: string
  /** @format uri */
  galleryUrl?: string
  /** @format uri */
  fullUrl?: string
  /** @format uri */
  dynamicUrl?: string
}

export interface SortOptions {
  hotel?: SortDetails
  pricingOption?: SortDetails
}

export interface SortDetails {
  /**
   * Field to sort by
   * @example "SORT_ORDER_TYPE_PRICE"
   */
  type?: SortType
  /**
   * Sort direction
   * @example "SORT_ORDER_DIRECTION_ASCENDING"
   */
  direction?: SortOrder
  sortItems?: SortItem[]
}

export interface SortItem {
  /** @example "12345" */
  itemId?: string
  /** @example 150.5 */
  value?: number
}

export interface PricingOption {
  /** @example "opt_001" */
  id?: string
  /** @example "booking_com" */
  agentId?: string
  /** @example "12345" */
  hotelId?: string
  /** @example "Deluxe Double Room" */
  roomName?: string
  /** @example "ROOM_TYPE_DOUBLE_ROOM" */
  roomType?: PricingOptionRoomTypeEnum
  /** @example "CANCELLATION_POLICY_TYPE_NON_REFUNDABLE" */
  cancellationPolicy?: CancellationTypeFilterValuesEnum
  /** @example "MEAL_PLAN_TYPE_BREAKFAST_INCLUDED" */
  mealPlan?: MealPlanFilterValuesEnum
  price?: Price
  priceWithoutDiscount?: Price
  /** @format uri */
  deeplink?: string
  /** @example "PAYMENT_TYPE_PAY_ON_ARRIVAL" */
  paymentType?: PaymentTypeFilterValuesEnum
}

export interface Price {
  /** @example "GBP" */
  currency?: string
  /** @example 150.5 */
  price?: number
  /** @example 130 */
  basePrice?: number
  taxesAndFees?: TaxAndFee[]
}

export interface TaxAndFee {
  /** @example "TAX_AND_FEE_TYPE_VAT" */
  feeType?: TaxAndFeeFeeTypeEnum
  /** @example 20.5 */
  value?: number
  /** @example "PAYMENT_TYPE_PREPAID" */
  payType?: PaymentTypeFilterValuesEnum
}

export type AnyValue = any

export interface ErrorResponse {
  /** Error code */
  code: string
  /** Detailed error message */
  message: string
  /** Array of error details */
  details?: AnyValue[]
}

export type ValidationError = ErrorResponse & {
  /**
   * Field-specific validation errors
   * @example {"currency":["Must be 3 uppercase letters"],"adults":["Must be at least 1"]}
   */
  fields?: Record<string, string[]>
}

/** @example "DISTANCE_UNIT_KILOMETER" */
export enum DistanceUnitCodeEnum {
  DISTANCE_UNIT_UNSPECIFIED = 'DISTANCE_UNIT_UNSPECIFIED',
  DISTANCE_UNIT_METER = 'DISTANCE_UNIT_METER',
  DISTANCE_UNIT_MILE = 'DISTANCE_UNIT_MILE',
  DISTANCE_UNIT_KILOMETER = 'DISTANCE_UNIT_KILOMETER',
}

export enum HotelsQueryIncludedEntityTypesEnum {
  PLACE_TYPE_AIRPORT = 'PLACE_TYPE_AIRPORT',
  PLACE_TYPE_CITY = 'PLACE_TYPE_CITY',
  PLACE_TYPE_COUNTRY = 'PLACE_TYPE_COUNTRY',
  PLACE_TYPE_HOTEL = 'PLACE_TYPE_HOTEL',
  PLACE_TYPE_DISTRICT = 'PLACE_TYPE_DISTRICT',
  PLACE_TYPE_ISLAND = 'PLACE_TYPE_ISLAND',
  PLACE_TYPE_FIRST_LEVEL_NATION_ADMINISTRATIVE_DIVISION = 'PLACE_TYPE_FIRST_LEVEL_NATION_ADMINISTRATIVE_DIVISION',
  PLACE_TYPE_SECOND_LEVEL_NATION_ADMINISTRATIVE_DIVISION = 'PLACE_TYPE_SECOND_LEVEL_NATION_ADMINISTRATIVE_DIVISION',
  PLACE_TYPE_SEA_COAST = 'PLACE_TYPE_SEA_COAST',
  PLACE_TYPE_MOUNTAIN_RANGE = 'PLACE_TYPE_MOUNTAIN_RANGE',
  PLACE_TYPE_SEA = 'PLACE_TYPE_SEA',
}

/** @example "PLACE_TYPE_CITY" */
export enum HotelsPlaceTypeEnum {
  PLACE_TYPE_UNSPECIFIED = 'PLACE_TYPE_UNSPECIFIED',
  PLACE_TYPE_AIRPORT = 'PLACE_TYPE_AIRPORT',
  PLACE_TYPE_CITY = 'PLACE_TYPE_CITY',
  PLACE_TYPE_COUNTRY = 'PLACE_TYPE_COUNTRY',
  PLACE_TYPE_HOTEL = 'PLACE_TYPE_HOTEL',
  PLACE_TYPE_DISTRICT = 'PLACE_TYPE_DISTRICT',
  PLACE_TYPE_ISLAND = 'PLACE_TYPE_ISLAND',
  PLACE_TYPE_FIRST_LEVEL_NATION_ADMINISTRATIVE_DIVISION = 'PLACE_TYPE_FIRST_LEVEL_NATION_ADMINISTRATIVE_DIVISION',
  PLACE_TYPE_SECOND_LEVEL_NATION_ADMINISTRATIVE_DIVISION = 'PLACE_TYPE_SECOND_LEVEL_NATION_ADMINISTRATIVE_DIVISION',
  PLACE_TYPE_SEA_COAST = 'PLACE_TYPE_SEA_COAST',
  PLACE_TYPE_MOUNTAIN_RANGE = 'PLACE_TYPE_MOUNTAIN_RANGE',
  PLACE_TYPE_SEA = 'PLACE_TYPE_SEA',
}

export enum HotelGuestTypeFilterValuesEnum {
  GUEST_TYPE_UNSPECIFIED = 'GUEST_TYPE_UNSPECIFIED',
  GUEST_TYPE_FAMILY = 'GUEST_TYPE_FAMILY',
  GUEST_TYPE_BUSINESS = 'GUEST_TYPE_BUSINESS',
  GUEST_TYPE_COUPLE = 'GUEST_TYPE_COUPLE',
  GUEST_TYPE_SOLO = 'GUEST_TYPE_SOLO',
  GUEST_TYPE_GROUP = 'GUEST_TYPE_GROUP',
  GUEST_TYPE_OTHER = 'GUEST_TYPE_OTHER',
}

/**
 * Current search status
 * @example "RESULT_STATUS_INCOMPLETE"
 */
export enum HotelSearchResponseStatusEnum {
  RESULT_STATUS_UNSPECIFIED = 'RESULT_STATUS_UNSPECIFIED',
  RESULT_STATUS_COMPLETE = 'RESULT_STATUS_COMPLETE',
  RESULT_STATUS_INCOMPLETE = 'RESULT_STATUS_INCOMPLETE',
  RESULT_STATUS_FAILED = 'RESULT_STATUS_FAILED',
}

/** @example "AGENT_TYPE_OTA" */
export enum AgentAgentTypeEnum {
  AGENT_TYPE_UNSPECIFIED = 'AGENT_TYPE_UNSPECIFIED',
  AGENT_TYPE_OTA = 'AGENT_TYPE_OTA',
  AGENT_TYPE_CHAIN = 'AGENT_TYPE_CHAIN',
  AGENT_TYPE_GROUP = 'AGENT_TYPE_GROUP',
  AGENT_TYPE_CRS = 'AGENT_TYPE_CRS',
  AGENT_TYPE_IBE = 'AGENT_TYPE_IBE',
}

/** @example "ACCOM_TYPE_HOTEL" */
export enum HotelContentAccommodationTypeEnum {
  ACCOM_TYPE_UNSPECIFIED = 'ACCOM_TYPE_UNSPECIFIED',
  ACCOM_TYPE_HOTEL = 'ACCOM_TYPE_HOTEL',
  ACCOM_TYPE_APARTMENT = 'ACCOM_TYPE_APARTMENT',
  ACCOM_TYPE_HOLIDAY_RENTALS = 'ACCOM_TYPE_HOLIDAY_RENTALS',
  ACCOM_TYPE_GUESTHOUSE = 'ACCOM_TYPE_GUESTHOUSE',
  ACCOM_TYPE_HOSTEL = 'ACCOM_TYPE_HOSTEL',
  ACCOM_TYPE_UNIQUE_STAYS = 'ACCOM_TYPE_UNIQUE_STAYS',
  ACCOM_TYPE_RESORT = 'ACCOM_TYPE_RESORT',
  ACCOM_TYPE_RESIDENCE_HOTEL = 'ACCOM_TYPE_RESIDENCE_HOTEL',
  ACCOM_TYPE_PRIVATE_HOME = 'ACCOM_TYPE_PRIVATE_HOME',
}

/** @example "IMAGE_TYPE_INTERIOR" */
export enum HotelImageTypeEnum {
  IMAGE_TYPE_UNSPECIFIED = 'IMAGE_TYPE_UNSPECIFIED',
  IMAGE_TYPE_OUTLOOK = 'IMAGE_TYPE_OUTLOOK',
  IMAGE_TYPE_BEDROOM = 'IMAGE_TYPE_BEDROOM',
  IMAGE_TYPE_INTERIOR = 'IMAGE_TYPE_INTERIOR',
  IMAGE_TYPE_BATHROOM = 'IMAGE_TYPE_BATHROOM',
  IMAGE_TYPE_OTHERS = 'IMAGE_TYPE_OTHERS',
  IMAGE_TYPE_BEACH = 'IMAGE_TYPE_BEACH',
  IMAGE_TYPE_LOBBY = 'IMAGE_TYPE_LOBBY',
  IMAGE_TYPE_POOL = 'IMAGE_TYPE_POOL',
  IMAGE_TYPE_MEETING_ROOM = 'IMAGE_TYPE_MEETING_ROOM',
  IMAGE_TYPE_RESTAURANT_BAR = 'IMAGE_TYPE_RESTAURANT_BAR',
  IMAGE_TYPE_GYM = 'IMAGE_TYPE_GYM',
}

/** @example "ROOM_TYPE_DOUBLE_ROOM" */
export enum PricingOptionRoomTypeEnum {
  ROOM_TYPE_UNSPECIFIED = 'ROOM_TYPE_UNSPECIFIED',
  ROOM_TYPE_GENERIC_ROOM = 'ROOM_TYPE_GENERIC_ROOM',
  ROOM_TYPE_SINGLE_ROOM = 'ROOM_TYPE_SINGLE_ROOM',
  ROOM_TYPE_DOUBLE_ROOM = 'ROOM_TYPE_DOUBLE_ROOM',
  ROOM_TYPE_TRIPLE_ROOM = 'ROOM_TYPE_TRIPLE_ROOM',
  ROOM_TYPE_SHARED_ROOM = 'ROOM_TYPE_SHARED_ROOM',
  ROOM_TYPE_FAMILY_ROOM = 'ROOM_TYPE_FAMILY_ROOM',
  ROOM_TYPE_SUITE_ROOM = 'ROOM_TYPE_SUITE_ROOM',
  ROOM_TYPE_JAPANESE_STYLE_ROOM = 'ROOM_TYPE_JAPANESE_STYLE_ROOM',
  ROOM_TYPE_JAPANESE_BED_ROOM = 'ROOM_TYPE_JAPANESE_BED_ROOM',
  ROOM_TYPE_TWIN_ROOM = 'ROOM_TYPE_TWIN_ROOM',
}

/** @example "TAX_AND_FEE_TYPE_VAT" */
export enum TaxAndFeeFeeTypeEnum {
  TAX_AND_FEE_TYPE_UNSPECIFIED = 'TAX_AND_FEE_TYPE_UNSPECIFIED',
  TAX_AND_FEE_TYPE_VAT = 'TAX_AND_FEE_TYPE_VAT',
  TAX_AND_FEE_TYPE_OTHER = 'TAX_AND_FEE_TYPE_OTHER',
  TAX_AND_FEE_TYPE_CITY = 'TAX_AND_FEE_TYPE_CITY',
  TAX_AND_FEE_TYPE_SERVICE = 'TAX_AND_FEE_TYPE_SERVICE',
  TAX_AND_FEE_TYPE_RESORT = 'TAX_AND_FEE_TYPE_RESORT',
  TAX_AND_FEE_TYPE_DESTINATION = 'TAX_AND_FEE_TYPE_DESTINATION',
  TAX_AND_FEE_TYPE_PAYMENT = 'TAX_AND_FEE_TYPE_PAYMENT',
}
